import { HEADER_COLORS } from 'constants/enums'
import config from 'config'

export default () => {
  const headerColor = config.headerColor

  if (headerColor) {
    if (headerColor === HEADER_COLORS.green.id) {
      return { backgroundColor: 'rgba(142, 196, 73, 0.64)' }
    } else if (headerColor === HEADER_COLORS.blue.id) {
      return { backgroundColor: 'rgba(9, 168, 213, 0.28)' }
    }
  } else {
    return {}
  }
}
